import { FullLoader } from '@openx/components-core/lib/Loader/FullLoader.tsx';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { getEnvironmentConfigs } from '../../../environmentConfigs.ts';
import { hasSessionId } from '../utils/verifyOAuthParams.ts';

export const Main = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { unityOrigin } = getEnvironmentConfigs();

  useEffect(() => {
    if (hasSessionId(location)) {
      navigate('/login');
    } else if (unityOrigin) {
      window.location.href = unityOrigin;
    }
  }, [location, navigate, unityOrigin]);

  return <FullLoader />;
};
